import React from "react";
import { Box, Typography, useTheme } from "@material-ui/core";
import { useFormContext } from "react-hook-form";
import { UtilityIcon } from "../../../components/UtilityIcon";
import { hasAllReadings } from "../utils/hasAllReadings";
import { hasAnyFormErrors, hasErrorsInTab } from "../utils/hasErrorsInTab";
import { ValidityIcon } from "./ValidityIcon";

export type MeterTabProps = {
  hasAPIError: boolean;
  hasAPIWarning: boolean;
  utilityType: string;
  meterPointIdentifier: string;
  meterId: string;
  meterIdentifier: string;
  registerCount: number;
};
export const MeterTab: React.FC<MeterTabProps> = ({
  hasAPIError,
  hasAPIWarning,
  utilityType,
  meterPointIdentifier,
  meterId,
  meterIdentifier,
  registerCount,
  ...other
}) => {
  const theme = useTheme();
  const {
    errors,
    formState: { dirtyFields },
  } = useFormContext();

  const hasErrors = hasAPIError || hasErrorsInTab(meterId, errors);
  const hasWarnings = hasAPIWarning && !hasAnyFormErrors(errors);
  const isValid =
    hasAllReadings(meterId, dirtyFields, registerCount) &&
    !hasErrors &&
    !hasWarnings;

  return (
    <Box display="flex" textAlign="left" minWidth={180} {...other}>
      <Box mr={0.5} mt={0.3}>
        <UtilityIcon
          type={utilityType}
          height={16}
          width={16}
          style={{ fill: "currentColor", color: theme.palette.primary.main }}
        />
      </Box>
      <Box>
        <Typography
          color="primary"
          data-testid="MeterPointDialog__Identifier"
          variant="caption"
        >{`${utilityType} ${meterPointIdentifier}`}</Typography>
        <Typography
          color="primary"
          data-testid="MeterPointDialog__MeterIdentifier"
        >
          {meterIdentifier}
        </Typography>
      </Box>
      <ValidityIcon
        isValid={isValid}
        isError={hasErrors}
        isWarning={hasWarnings}
      />
    </Box>
  );
};
